import { css } from '@emotion/react';
import { darken, transparentize } from 'polished';


export default ($) => {
  const {
    primaryMain,
    infoMain,
    white,
  } = $;

  const formtabColor = primaryMain;
  const formtabHoverColor = darken(0.2, formtabColor);
  const formtabHoverBg = transparentize(0.95, formtabColor);

  return css`
    .uweentity-form-nav-panel {
      color: ${formtabColor};
      overflow: hidden;
      max-height: calc(100vh - 200px);
      height: 100%;

      .scroller {
        overflow: hidden auto;
        max-height: calc(100vh - 200px);
      }

      &.expanded {
        max-width: 320px;
        .scroller {
          padding: 1rem 1rem;
          max-width: 320px;
        }
        border-radius: 0.5rem;
        text-align: center;
      }

      h5 {
        margin-bottom: 0.5rem;
        cursor: default;
      }

      ul.nav {
        border-top: 1px ${formtabColor} solid;
        border-bottom: 1px ${formtabColor} solid;
      }

      a {
        color: ${infoMain};
        cursor: pointer;
      }

      .nav-item {
        border-radius: 0.5rem;

        > * {
          border-left-width: 7px;
          border-left-style: solid;
          border-radius: 0;
          border-color: transparent;
        }

        > :hover {
          color: ${formtabHoverColor};
          background: ${formtabHoverBg};
        }

        > .active {
          border-left-color: ${formtabColor};
          background: ${white};
          color: ${infoMain};
        }
      }

      .separator {
        height: 1px;
        background-color: ${formtabColor};
        margin: 0 10%;
      }

      .section-title {
        color: ${formtabColor};
      }
    }
  `;
}
